import React from 'react';
import { FaMapMarkerAlt, FaClock, FaPhone, FaWhatsapp } from 'react-icons/fa';

const Location = () => {
  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Endereço',
      info: 'R. Adelino Marucci, 201',
      subinfo: 'Vila Nova - Araçariguama, SP',
      link: 'https://maps.google.com/?q=R.+Adelino+Marucci,+201+-+Vila+Nova,+Araçariguama+-+SP,+18147-000'
    },
    {
      icon: <FaPhone />,
      title: 'Telefone',
      info: '(11) 97291-8839',
      subinfo: 'Seg-Sex: 8h-12h, 13h-18h',
      link: 'tel:+5511972918839'
    },
    {
      icon: <FaWhatsapp />,
      title: 'WhatsApp',
      info: '(11) 97291-8839',
      subinfo: 'Atendimento rápido',
      link: 'https://wa.me/5511972918839'
    }
  ];

  const schedule = [
    { day: 'Segunda-feira', hours: '08:00-12:00, 13:00-18:00' },
    { day: 'Terça-feira', hours: '08:00-12:00, 13:00-18:00' },
    { day: 'Quarta-feira', hours: '08:00-12:00, 13:00-18:00' },
    { day: 'Quinta-feira', hours: '08:00-12:00, 13:00-18:00' },
    { day: 'Sexta-feira', hours: '08:00-12:00, 13:00-18:00' },
    { day: 'Sábado', hours: '08:00-13:00' },
    { day: 'Domingo', hours: 'Fechado', closed: true }
  ];

  return (
    <section id="contato" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">Localização</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-secondary-dark mt-3 mb-4">
            Venha Nos Visitar
          </h2>
          <p className="text-gray-600 text-lg">
            Estamos localizados em um ponto de fácil acesso no centro da cidade. 
            Entre em contato ou venha conhecer nossa estrutura.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
          {contactInfo.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target={item.link.startsWith('http') ? '_blank' : '_self'}
              rel={item.link.startsWith('http') ? 'noopener noreferrer' : ''}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-200 hover:border-accent hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center text-accent text-xl mb-4 group-hover:scale-110 transition-transform mx-auto">
                {item.icon}
              </div>
              <h3 className="font-bold text-secondary-dark mb-2 text-center">{item.title}</h3>
              <p className="text-gray-700 font-medium mb-1 text-center">{item.info}</p>
              <p className="text-sm text-gray-500 text-center">{item.subinfo}</p>
            </a>
          ))}
        </div>

        {/* Map and Schedule */}
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg h-full min-h-[400px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3660.123!2d-47.0612!3d-23.4378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf5c8b8e8b8b8b%3A0x8b8b8b8b8b8b8b8b!2sR.%20Adelino%20Marucci%2C%20201%20-%20Vila%20Nova%2C%20Araçariguama%20-%20SP%2C%2018147-000!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '400px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização da Oficina"
              ></iframe>
            </div>
          </div>

          {/* Schedule */}
          <div className="bg-gradient-to-br from-secondary-dark via-black to-secondary rounded-2xl p-8 text-white shadow-2xl border border-primary/20">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                <FaClock className="text-2xl text-primary" />
              </div>
              <h3 className="text-2xl font-bold">Horário de Funcionamento</h3>
            </div>

            <div className="space-y-3">
              {schedule.map((item, index) => (
                <div
                  key={index}
                  className={`flex justify-between items-center py-3 border-b border-white/10 ${
                    item.closed ? 'opacity-50' : ''
                  }`}
                >
                  <span className="font-medium">{item.day}</span>
                  <span className={`font-bold ${item.closed ? 'text-gray-400' : 'text-primary'}`}>
                    {item.hours}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-sm text-gray-200 mb-4">
                <strong>Importante:</strong> Recomendamos agendar seu horário para garantir 
                atendimento prioritário.
              </p>
              <a
                href="https://wa.me/5511972918839?text=Olá!%20Gostaria%20de%20agendar%20um%20horário%20na%20Mecânica%20Box%2050"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-accent hover:bg-accent-dark text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 text-center"
              >
                Agendar Agora
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Location;
